export default {
  contentTypeOptions: [
    {
      text: 'Прямой эфир',
      value: 'live'
    },
    {
      text: 'Телешоу',
      value: 'tv_show'
    },
    {
      text: 'Сериал',
      value: 'tv_series'
    },
    {
      text: 'Мультсериал',
      value: 'cartoon_series'
    },
    {
      text: 'Мультфильм',
      value: 'cartoon'
    },
    {
      text: 'Фильм',
      value: 'film'
    },
    {
      text: 'Концерт',
      value: 'concert'
    },
    {
      text: 'Спортивная трансляция',
      value: 'sports_broadcast'
    }
  ],
  priorityOptions: [
    {
      text: 'Высокий',
      value: 'hight'
    },
    {
      text: 'Обычный',
      value: 'normal'
    }
  ],
  rightsTypeOptions: [
    {
      text: 'AVOD',
      value: 'AVOD'
    },
    {
      text: 'SVOD',
      value: 'SVOD'
    },
    {
      text: 'TVOD',
      value: 'TVOD'
    },
    {
      text: 'BVOD',
      value: 'BVOD'
    },
    {
      text: 'EST',
      value: 'EST'
    },
    {
      text: 'PayTV',
      value: 'PayTV'
    },
    {
      text: 'FreeTV',
      value: 'FreeTV'
    },
    {
      text: 'Кинопрокат/кинопоказ',
      value: 'film_distribution'
    }
  ],
  stateOptions: [
    {
      text: 'Ожидает модерации',
      value: 'waiting_for_moderation'
    },
    {
      text: 'Отклонена',
      value: 'rejected'
    },
    {
      text: 'Активна',
      value: 'active'
    },
    {
      text: 'Неактивна',
      value: 'no_active'
    },
    {
      text: 'Истекла',
      value: 'expired'
    },
    {
      text: 'В работе',
      value: 'in_work'
    },
    {
      text: 'Обработано',
      value: 'accept'
    },
    {
      text: 'Удалено',
      value: 'deleted'
    },
    {
      text: 'Новая',
      value: 'is_new'
    }
  ],
  roleOptions: [
    {
      text: 'Модератор',
      value: 'moder'
    },
    {
      text: 'Заявитель',
      value: 'filer'
    }
  ],
  activeOptions: [
    {
      text: 'Неактивен',
      value: false
    },
    {
      text: 'Активен',
      value: true
    }
  ]
};
